/**
 * One-time initialisation of the RaptorQ WASM module for the QweRty layer.
 * In the browser Vite rewrites the generated module's wasm URL; in Node the
 * caller can pre-initialise with initSync and this becomes a no-op.
 */
import init from '@qwerty/raptorq-wasm';

let initPromise: Promise<void> | null = null;

export function ensureQwertyWasm(): Promise<void> {
  if (!initPromise) {
    initPromise = Promise.resolve(init())
      .then(() => undefined)
      .catch((err) => {
        initPromise = null;
        throw err;
      });
  }
  return initPromise;
}
